var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/core-js/library/modules/$.cof.js
// module id = ./node_modules/vue2-google-maps/node_modules/core-js/library/modules/$.cof.js
// module chunks = 0